import { Grid } from "@mui/material";
import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import { GetPaymentSettlmentInfoResponse } from "../../../models/supplierPayment.model";
export default function DetailInfo_settlementRegisterHistory({
  detailInfo,
}: {
  detailInfo: GetPaymentSettlmentInfoResponse;
}) {
  return (
    <div
      className={"mTop30"}
      style={{
        // width: "98%",
        margin: "-2vh auto 3vh",
        background: "#F9FAFC",
        paddingBottom: "2vh",
        border: "1px solid #DAE0E4",
        borderRadius: "5px",
      }}
    >
      <span
        className="colorTitle fontWeight textFont16 mbottom10"
        style={{
          marginTop: "-13px",
          marginRight: "20px",
          paddingRight: "5px",
          paddingLeft: "5px",
          display: "block",
          background: "#fff",
          width: "285px",
          borderRadius: "10px",
          height: "18px",
        }}
      >
        <PersonIcon />
        &nbsp; مشخصات ثبت کننده درخواست تسویه
      </span>

      <div
        className="cardBorderTitle borderCOlor"
        style={{ borderBottom: "1px solid #DAE0E4", margin: "5px 35px" }}
      >
        <Grid
          item
          xs={12}
          container
          style={{ lineHeight: "3vh", marginTop: "20px", marginBottom: "15px" }}
        >
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}>نام و نام خانوادگی:&nbsp;</span>
            <b style={{ color: "#34495E" }}> {detailInfo.creatorUserTitle} </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> تاریخ و ساعت ایجاد:&nbsp;</span>
            <b style={{ color: "#34495E" }}> {detailInfo.createPersianDate} </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> نوع تسویه:&nbsp;</span>
            <b style={{ color: "#34495E" }}>
              {" "}
              {detailInfo.settlementTypeTitle}
            </b>
          </Grid>
          <Grid item xs={4} md={3} style={{ padding: "5px" }}>
            <span style={{ color: "#9AAFC4" }}> مبلغ تسویه:&nbsp;</span>
            <b style={{ color: "#34495E" }}>
              {" "}
              {detailInfo.settlementAmount?.toLocaleString("fa")} ریال
            </b>
          </Grid>
          {detailInfo.settlementType == "Cheque" && (
            <>
              <Grid item xs={3} md={3} style={{ padding: "5px" }}>
                <span style={{ color: "#9AAFC4" }}>
                  {" "}
                  تاریخ 
                   سررسید چک:&nbsp;
                </span>
                <b style={{ color: "#34495E" }}>
                  {detailInfo.chequeDuePersianDate}{" "}
                </b>
              </Grid>
              <Grid item xs={3} md={3} style={{ padding: "5px" }}>
                <span style={{ color: "#9AAFC4" }}> سری / سریال چک:&nbsp;</span>
                <b style={{ color: "#34495E" }}>
                  {detailInfo.chequeSeri &&
                    detailInfo.chequeSeri + " / " + detailInfo.chequeSerial}
                </b>
              </Grid>
              <Grid item xs={3} md={3} style={{ padding: "5px" }}>
                <span style={{ color: "#9AAFC4" }}> شماره صیادی:&nbsp;</span>
                <b style={{ color: "#34495E" }}>
                  {detailInfo.chequeSayadNumber}{" "}
                </b>
              </Grid>
            </>
          )}
          {detailInfo.settlementType !== "Cheque" && (
            <>
              <Grid item xs={3} md={3} style={{ padding: "5px" }}>
                <span style={{ color: "#9AAFC4" }}> شماره تراکنش:&nbsp;</span>
                <b style={{ color: "#34495E" }}>
                  {" "}
                  {detailInfo.transactionNumber}
                </b>
              </Grid>
              <Grid item xs={3} md={3} style={{ padding: "5px" }}>
                <span style={{ color: "#9AAFC4" }}>
                  {" "}
                  تاریخ و ساعت واریز:&nbsp;
                </span>
                <b style={{ color: "#34495E" }}>
                  {detailInfo.transactionPersianDate}{" "}
                </b>
              </Grid>
            </>
          )}
        </Grid>
      </div>
      <Grid
        item
        xs={12}
        container
        style={{
          lineHeight: "3vh",
          marginTop: "20px",
          marginBottom: "15px",
          marginRight: "15px",
        }}
      >
        <Grid item xs={12} md={6}>
          <Grid
            container
            xs={12}
            style={{
              marginRight: "25px",
            }}
          >
            <Grid item xs={3} style={{ maxWidth: "fit-content" }}>
              <span style={{ color: "#9AAFC4" }}>
                {" "}
                توضیحات ثبت کننده:&nbsp;
              </span>
            </Grid>
            <Grid item xs={8} style={{ marginRight: ".5vh" }}>
              <b style={{ color: "#34495E" }}>
                {detailInfo.creatorDescription}
              </b>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container xs={12}>
            <Grid item xs={3} style={{ maxWidth: "fit-content" }}>
              <span style={{ color: "#9AAFC4" }}>
                {" "}
                توضیحات واریز کننده:&nbsp;
              </span>
            </Grid>
            <Grid item xs={8} style={{ marginRight: ".5vh" }}>
              <b style={{ color: "#34495E" }}>
                {detailInfo.finalizerDescription}
              </b>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
